import Home from "../../component/home/Home";
import MobileHome from "../../component/mobile/home/M_Home";

const HomeComponent = () => {
  return (
    <div className="HOME">
      {window.innerWidth > 1000 && <Home />}
      {window.innerWidth < 1000 && <MobileHome />}
    </div>
  );
};

export default HomeComponent;
